import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ProductNotPackageComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    product: flights.ProductModel;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    mounted() {
        const stepNumber = this.product.product.stepNumber;
        const kitId = this.product.product!.kitId || '';
        const id = this.product.product.id;
        const label = `product.step${stepNumber}.kit${kitId}.id${id}`;

        if(!this.gaAlreadySubmitted.includes(label)) {
            (<any>this).$ga.sendEvent('product',
                'display',
                label,
                this.gaParams
            );
            this.gaAlreadySubmitted.push(label);
        }
    }

    onProductDetails(product: flights.ProductModel) {
        (<any>this).$ga.sendEvent('product',
            'detail',
            `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
            this.gaParams
        );

        this.$emit('product-details', product);
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        if(product.product.id == 15 && value == false && !!0) { // временное ограничение на показ окна
            (<any>this).$ga.sendEvent(
                'product.popup',
                'display',
                `product.popup.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
                this.gaParams
            );
            const self = <any>this;
            (<any>this.$root).$refs.dialogCatchUp.show({
                text: 'Вы уверены, что хотите отказаться от услуги <b>Возврат без потерь</b> и остаться без компенсации в случае возврата билета?',
                btnOkLabel: 'Оставить услугу в заказе',
                btnOkColorClass: 'btn-alternate',
                persistent: false,
                btnOkHandler: function() {
                    self.$ga.sendEvent(
                        'product.popup',
                        'btn.ok',
                        `product.popup.step${self.product.product.stepNumber}.kit${self.product.product!.kitId || ''}.id${self.product.product.id}`,
                        this.gaParams
                    );
                    (<any>this).$refs.dialog.hide();
                },
                btnCancelLabel: 'Отказаться от услуги',
                btnCancelHandler: () => {
                    product.selected = value;

                    (<any>this).$ga.sendEvent(
                        'product.popup',
                        'btn.cancel',
                        `product.popup.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
                        this.gaParams
                    );
                },
                btnCloseHandler: function(){
                    (<any>this).$refs.dialog.hide();
                }
            });
        } else {
            product.selected = value;
        }

        (<any>this).$ga.sendEvent(
            'product',
            value ? 'btn.ok' : 'btn.cancel',
            `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
            this.gaParams
        );
        if (value) {
            new api.RetailRocket().productSelected({
                flightKey: api.RetailRocketCL.flightKey,
                productId: product.product.id,
                bookingSessionId: this.reservation.bookingSessionId ?? undefined
            });
        }

        if (value && product.product.additionalProcessing) {
            this.$nextTick(() => {
                (<any>this.$root).$refs.dialogCatchUp.show({
                    text: 'Извините, услуга сейчас недоступна, но вы сможете купить ее позже ❤️',
                    btnOkLabel: 'OK',
                    persistent: true,
                    btnOkColorClass: 'btn-alternate',
                    btnOkHandler() {
                        (<any>this).$refs.dialog.hide();
                    }
                });
                this.product.selected = false;
            });
            return;
        }

        // @todo отрефакторить
        // Проверка на наличие пакета в выбранных
        if(value) {
            this.reservation.selectedProducts.forEach(item => {
                if(item.product.internalProductIds){
                    item.product.internalProductIds.forEach(inPackage => {
                        if(inPackage == product.product.id) {
                            // Вызов модалки
                            (<any>this.$root).$refs.dialogCatchUp.show({
                                text: `Эта услуга уже есть в <b>${item.product.name}</b>`,
                                btnOkLabel: 'Ok',
                                persistent: true,
                                btnOkColorClass: 'btn-alternate',
                                btnOkHandler: function(){
                                    (<any>this).$refs.dialog.hide();
                                }
                            });
                            product.selected = false;
                            return 0;
                        }
                    });
                }
            });
        }

        if (value) {
            product.choiceType = api.ProductChoiceType.manualAccepted;
        }
    }
}
